// import
import Component from 'minsky-kit/js/components/Component';
// private statics
const scrollVariable = { top: 0, left: 0, animating: false };

// class definition
export default class CombinedMenus extends Component {
    // constructor
    constructor (args = {}, objectName = 'CombinedMenus') {
        // debug toggle
        args.debug = args.debug || true;

        // super constructor
        super(args, objectName);

        this.main = this.$el.querySelector('.menu--main ul');
        this.sec = this.$el.querySelector('.menu--secondary-menu');
        this.secItems = Array.from(this.$el.querySelectorAll('.menu--secondary-menu > ul > li'));

        this.combine();
    }

    combine () {
        this.secItems.forEach($item => {
            this.main.appendChild($item);
        });

        this.sec.parentNode.removeChild(this.sec);
    }

    // methods
    refresh () {

    }

    destroy () {
        super.destroy();
    }
}